import React from 'react';
import PropTypes from 'prop-types';
import APTable from '../common/APTable';
import PaddedDecimal from '../common/PaddedDecimal/PaddedDecimal';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { formatTime } from '../../helpers/dateHelper';
import { convertIncrementToIntDecimalPlaces } from '../../helpers/decimalPlaces/decimalPlacesHelper';
import './RecentTradesComponent.css';
var baseClass = getBEMClasses('recent-trades');
var RecentTradesComponent = function RecentTradesComponent(props, context) {
  var selectedInstrument = props.selectedInstrument,
    recentTrades = props.recentTrades,
    fetching = props.fetching;
  var columns = [{
    header: context.t('Price'),
    cell: function cell(row) {
      return React.createElement('div', {
        className: baseClass('table-price', row.TakerSide === 0 ? 'buy' : 'sell')
      }, React.createElement(PaddedDecimal, {
        value: row.Price,
        bemMod: row.TakerSide === 0 ? 'buy' : 'sell',
        decimals: convertIncrementToIntDecimalPlaces(selectedInstrument.PriceIncrement)
      }));
    }
  }, {
    header: context.t('Qty'),
    cell: function cell(row) {
      return React.createElement('div', {
        className: baseClass('table-qty')
      }, React.createElement(PaddedDecimal, {
        value: row.Quantity,
        decimals: convertIncrementToIntDecimalPlaces(selectedInstrument.QuantityIncrement)
      }));
    }
  }, {
    header: context.t('Time'),
    cell: function cell(row) {
      return React.createElement('div', {
        className: baseClass('table-time')
      }, formatTime(row.Timestamp));
    }
  }];
  return React.createElement(APTable, {
    columns: columns,
    rows: recentTrades,
    baseClass: baseClass,
    empty: context.t('No recent trades'),
    fetching: fetching
  });
};
RecentTradesComponent.propTypes = {
  recentTrades: PropTypes.arrayOf(PropTypes.shape({
    TradeId: PropTypes.number.isRequired,
    TakerSide: PropTypes.number.isRequired,
    Price: PropTypes.object.isRequired,
    Quantity: PropTypes.object.isRequired,
    Timestamp: PropTypes.number.isRequired
  }))
};
RecentTradesComponent.defaultProps = {
  recentTrades: []
};
RecentTradesComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default RecentTradesComponent;